export function printOvertimeRule({ hours, days }: any) {
  return `${hours} hours per ${days} days`;
}
